import { useCallback, useState } from "react"
import useModalFocus from "@onestore/hel/dist/hooks/useModalFocus"
import type { GaEvent } from "~/fragments/gaEvent"
import { sendGaEvent } from "~/lib/analytics"

type ModalStateHook = {
  isOpen: boolean
  open: { (): void }
  close: { (): void }
}

export default function useModalState(gaEvent?: GaEvent): ModalStateHook {
  const [isOpen, setIsOpen] = useState(false)
  const { handleFocusOnModalClose } = useModalFocus()

  const open = useCallback(() => {
    setIsOpen(true)
    sendGaEvent(gaEvent)
  }, [isOpen])

  const close = useCallback(() => {
    setIsOpen(false)
    handleFocusOnModalClose()
  }, [isOpen])

  return { isOpen, open, close }
}
